import { useEffect } from 'react'

import { type DatePickerAnchorOptions } from '../../DatePicker/anchorPositioning'

import { useDatePickerAnchorPosition } from '../useDatePickerAnchorPosition'
import { setupDropdownListeners } from './dropdownHelpers'

// DatePicker position effect
export function useDatePickerPositionEffect(
  datePickerState: {
    companyId: string
    roleId: string
    field: 'startDate' | 'endDate'
    position: { top: number; left: number; width: number }
    triggerKey: string
  } | null,
  dateFieldRefs: React.MutableRefObject<{ [key: string]: HTMLElement | null }>,
  setDatePickerState: React.Dispatch<React.SetStateAction<{
    companyId: string
    roleId: string
    field: 'startDate' | 'endDate'
    position: { top: number; left: number; width: number }
    triggerKey: string
  } | null>>,
  datePickerRef: React.RefObject<HTMLElement | null>,
  scrollRootRef?: React.RefObject<HTMLElement | null>,
) {
  const options: DatePickerAnchorOptions = { monthYearOnly: true }
  useDatePickerAnchorPosition(
    datePickerState,
    dateFieldRefs,
    setDatePickerState,
    datePickerRef,
    options,
    scrollRootRef,
  )
}

// Dropdown listeners effect
export function useDropdownListenersEffect(
  openTypeDropdown: { companyId: string; roleId: string } | null,
  typeDropdownRefs: React.MutableRefObject<{ [key: string]: HTMLElement | null }>,
  handleCloseTypeDropdown: () => void
) {
  useEffect(() => {
    if (!openTypeDropdown) return
    return setupDropdownListeners(openTypeDropdown.companyId, openTypeDropdown.roleId, typeDropdownRefs, handleCloseTypeDropdown)
  }, [openTypeDropdown, typeDropdownRefs, handleCloseTypeDropdown])
}
